import { useCallback, useEffect, useState } from 'react'
import { Trans } from 'react-i18next'

import { BuilderMenu, COND_FEATURE_FLAG_ALL, ConditionFeatureFlag, ConditionValue } from '@makyoapp/makyo-common'

import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { AccordionItem } from '@/components/Accordion/Accordion'
import { VisibilitySelector } from '@/components/BehaviourV2/VisibilitySelector'

/**
 * MenuBehaviorAccordion is a function component that provides an interface for editing the behavior of a menu in a builder.
 */
function MenuBehaviorAccordion({ menu, menuIdx }: { menu: BuilderMenu; menuIdx: number }) {
  const { updateMenu } = useAppBuilderContext()
  const [localValue, setLocalValue] = useState<ConditionValue | null>(menu.visibility ?? null)

  useEffect(() => {
    setLocalValue(menu.visibility ?? null)
  }, [menu.visibility])

  const handleVisibilityChange = useCallback(
    (nextValue: ConditionValue | null) => {
      setLocalValue(nextValue)

      updateMenu(menuIdx, (prev) => {
        if (nextValue === null) {
          prev.visibility = undefined as any
        } else {
          prev.visibility = nextValue
        }
      })
    },
    [menuIdx, updateMenu]
  )

  return (
    <AccordionItem itemId='behavior-settings' title={<Trans>Behavior</Trans>}>
      <VisibilitySelector
        value={localValue}
        featureFlags={COND_FEATURE_FLAG_ALL & ~ConditionFeatureFlag.CurrentRow}
        onChange={handleVisibilityChange}
      />
    </AccordionItem>
  )
}

export default MenuBehaviorAccordion
